export default {
    country: 'country',
    region: 'region',
    province: 'province',
    city: 'city',
    "_levels":[{
        zoom: 6,
        name: 'country'
    },{
        zoom: 8,
        name: 'region'
    },{
        zoom: 10,
        name: 'province'
    },{
        zoom: 99,
        name: 'city'
    }],
    getByZoom(_zoom,filters) {
        if (filters){
            if (filters.filtro_biometano || filters.filtro_selfservice || filters.filtro_autostradali || filters.filtro_hiperformance){
                return {
                    zoom: 99,
                    name: 'city'
                };
            }
        }

        var result = this._levels.find(obj => {
            return obj.zoom >= _zoom
        });

        if (result.zoom===10 && filters && filters.filtro_bestprice){
            // con il filtro best price attivo, i distributori si vedono già a livello regionale
            return {
                zoom: 99,
                name: 'city'
            };
        }

        return result;
    },
    getByName(_name) {
        var result = this._levels.find(obj => {
            return obj.name.toLowerCase() === _name.toLowerCase()
        });

        return result;
    },
    getNextZoom(_name) {
        return this.getByName(_name).zoom+1;
    }
}